import Grid from '@mui/material/Grid';
import Modal from '@mui/material/Modal';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import DetailField from 'components/form/field/field';
import { MMITService } from 'clients/mmit-client';
import withStyles from '@mui/styles/withStyles';
import { getModalStyle } from 'services/utils/styles-service';
import CircularProgress from '@mui/material/CircularProgress';
import { Button } from '@mui/material';
import { FinancialAssistanceFundsStyles } from './styles';

const FinancialAssistanceFundsDetail: React.FC<any> = (props: any): JSX.Element => {
  const { classes, programId } = props;
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [id, setId] = useState(programId);

  useEffect(() => {
    setId(programId);
    console.log('PROGRAM ', programId);
    if (programId > 0) {
      setLoading(true);
      MMITService.getProgramById(programId)
        .then(result => {
          console.log('DATA ', result);
          setData(result);
          setLoading(false);
        })
        .catch(err => setLoading(false));
    }
  }, [programId]);

  return (
    <Modal open={id > 0} onClose={() => setId(0)}>
      <div className={classes.modal} style={{ ...getModalStyle() }}>
        {loading && <CircularProgress />}
        {!loading && (
          <Grid container gap={1} spacing={1}>
            <Grid item xs={12}>
              <DetailField fieldName="Program Name" field={data?.ProgramName} />
            </Grid>
            <Grid item xs={12}>
              <DetailField
                fieldName="Therapeutic Areas"
                field={data?.TherapeuticAreas?.join(', ')}
              />
            </Grid>
            <Grid item xs={12}>
              <DetailField fieldName="Drugs" field={data?.Drugs?.join(', ')} />
            </Grid>
            <Grid item xs={12}>
              <DetailField
                fieldName="Coverage Eligibilities"
                field={data?.CoverageEligibilities?.join(', ')}
              />
            </Grid>
            <Grid item xs={6}>
              <DetailField fieldName="Fund Levels" field={data?.FundLevels?.join(', ')} />
            </Grid>
            <Grid item xs={6}>
              <DetailField fieldName="Manufacturers" field={data?.Manufacturers?.join(', ')} />
            </Grid>
            <Grid item xs={12}>
              <DetailField isHref fieldName="Program URL" field={data?.ProgramURL} />
            </Grid>
            <Grid item xs={6}>
              <DetailField fieldName="Help Line" field={data?.HelpLine} />
            </Grid>
            <Grid item xs={6}>
              <DetailField
                fieldName="Enrollment Request"
                field={data?.EnrollmentReq ? 'Yes' : 'No'}
              />
            </Grid>
            <Grid item xs={12}>
              <DetailField isHref fieldName="Enrollment URL" field={data?.EnrollmentURL} />
            </Grid>
            <Grid item xs={12}>
              <DetailField fieldName="Expiration Date" field={data?.ExpirationDate} />
            </Grid>
            <Grid item xs={12}>
              <DetailField fieldName="Est App Time" field={data?.EstAppTime} />
            </Grid>
            <Grid item xs={12}>
              <DetailField fieldName="Eligibility Details" field={data?.EligibilityDetails} />
            </Grid>
            <Grid item xs={12}>
              <DetailField fieldName="Income Req" field={data?.IncomeReq ? 'Yes' : 'No'} />
            </Grid>
            <Grid item xs={12}>
              <DetailField fieldName="Income Details" field={data?.IncomeDetails} />
            </Grid>
            <Grid item xs={12}>
              <DetailField fieldName="Annual Max" field={data?.AnnualMax} />
            </Grid>
            <Grid item xs={12}>
              <DetailField fieldName="Maximum Benefit" field={data?.MaximumBenefit} />
            </Grid>
            <Grid item xs={12}>
              <DetailField
                fieldName="Offer Renewable"
                field={data?.OfferRenewable ? 'Yes' : 'No'}
              />
            </Grid>
            <Grid item xs={12}>
              <DetailField fieldName="Renewal Method" field={data?.RenewalMethod} />
            </Grid>
            <Grid item xs={12}>
              <DetailField fieldName="Add Renewal Details" field={data?.AddRenewalDetails} />
            </Grid>
            <Grid item xs={12}>
              <DetailField fieldName="Program Details" field={data?.ProgramDetails} />
            </Grid>
            <Grid item xs={12}>
              <DetailField fieldName="AssistanceType" field={data?.AssistanceType} />
            </Grid>
          </Grid>
        )}
        {!loading && (
          <Grid container>
            <Grid item xs={12} className={classes.btnArea}>
              <Button name="Close" type="button" variant="contained" onClick={() => setId(0)}>
                Close
              </Button>
            </Grid>
          </Grid>
        )}
      </div>
    </Modal>
  );
};
export default withStyles(FinancialAssistanceFundsStyles, { withTheme: true })(
  FinancialAssistanceFundsDetail,
);
